import React, { useEffect, useState } from "react";
import uniqueId from "lodash.uniqueid";
import { Plan, StarRating as StarRatingType } from "../../../@types";
import {
  ExpandIcon,
  OriginalMedicareStarRatings,
  StarRating,
} from "../../../components";

export interface StarRatingRowProps {
  color?: string;
  label?: string;
  starRating?: StarRatingType;
  onClick: () => void;
  open: boolean;
  showOriginalMedicareStars?: boolean;
  plan: Plan;
  ariaLabel?: string;
}

const StarRatingRow: React.FunctionComponent<StarRatingRowProps> = ({
  color: originalColor,
  label,
  starRating,
  onClick,
  open,
  showOriginalMedicareStars,
  plan,
  ariaLabel,
  children,
  ...props
}) => {
  let stars = null;
  const color = originalColor || "white";
  const [containerId, setContainerId] = useState("");

  if (typeof starRating !== "undefined") {
    stars = (
      <StarRating
        stars={starRating}
        includeLabel={false}
        planYear={plan.contract_year}
      />
    );
  }

  useEffect(() => {
    setContainerId(uniqueId("star_ratings_container_"));
  }, []);

  return (
    <div
      className="StarRatingExpandableRow"
      data-testid="star-rating-expandable-row"
      {...props}
    >
      <button
        className={`StarRatingExpandableRow__toggle StarRatingExpandableRow__toggle__${color}`}
        data-testid="rating-row-button"
        onClick={onClick}
        aria-expanded={open}
        aria-controls={containerId}
      >
        <div className="ds-u-display--flex mct-u-width--full">
          <ExpandIcon
            expanded={open}
            className="ds-u-margin-right--1 mct-c-icon--variant-bold"
          />
          <div className="ds-u-display--flex ds-u-flex-wrap--wrap ds-u-md-flex-wrap--nowrap ds-u-justify-content--between mct-u-width--full">
            <h3
              data-testid="rating-row-label"
              className={"StarRatingsSection__heading"}
              aria-label={ariaLabel}
            >
              {label}
            </h3>
            {stars}
          </div>
        </div>
      </button>
      {open && showOriginalMedicareStars && (
        <div className="StarRatingRow">
          <OriginalMedicareStarRatings plan={plan} />
        </div>
      )}
      {open && (
        <div id={containerId} data-testid="row-children">
          {children}
        </div>
      )}
    </div>
  );
};

export default StarRatingRow;
